/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */

export const makeDocsLink = (resource: string): string => {
  const url = new URL(`https://docs.microsoft.com/${resource}`);
  url.searchParams.set('referrer', 'developerportal');
  return url.toString();
};
